const AiPowered = () => {
  return (
    <>
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.1712 5.4875L26.515 7.31625L24.6875 10.975L22.86 7.31625L19.2038 5.4875L22.86 3.65875L24.6875 0L26.515 3.65875L30.1712 5.4875ZM11.7375 9.13125L9.32625 17.675H14.4225L12.0113 9.13125C11.975 8.98875 11.7725 8.98875 11.7375 9.13125ZM25 13.3C20.5125 13.3 16.875 9.6625 16.875 5.175C16.875 3.2875 17.525 1.555 18.605 0.175H3.75C1.6825 0.175 0 1.8575 0 3.925V30.175H30V11.57C28.62 12.65 26.8875 13.3 25 13.3ZM16.1875 23.925L15.1287 20.175H8.62125L7.5625 23.925H5L9.29875 8.4725C9.475 7.7125 9.975 7.0725 10.6712 6.71625C11.3812 6.35125 12.1963 6.32875 12.97 6.65375C13.7038 6.96125 14.2662 7.675 14.475 8.5725L18.75 23.9262L16.1875 23.925ZM23.75 23.925H21.25V15.175H23.75V23.925Z"
          fill="#9A252D"
        />
      </svg>
    </>
  );
};

export default AiPowered;
